import api from '../../../api.js'
import {handleResponseErrors} from '../../services/processServerErrors.js'

export default async function (values) {
  return api.users.edit(values).catch(handleResponseErrors)
}